module.exports = __webpack_public_path__ + "img/DTYLX_rus.f7bce1f6.png";